

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class KbReturnRequestFileService {
    //tickets
    filesSubject: BehaviorSubject<File[]> = new BehaviorSubject([]);
    files$: Observable<File[]> = this.filesSubject.asObservable();
    //others
    nullFileSubject: BehaviorSubject<any> = new BehaviorSubject({});
    filesMapSubject: BehaviorSubject<any> = new BehaviorSubject({});
    filesMap$: Observable<{ [partNumber: string]: File[] }> = this.filesMapSubject.asObservable();
    fileLength$: Observable<any> = new BehaviorSubject(null);

    constructor(protected occEndpointsService: OccEndpointsService, protected http: HttpClient) { }

    addFile(file: File, partNumber: string, index: number): void {
        if (partNumber.includes('/')) {
            const currentFilesMap = this.filesMapSubject.getValue();
            const updatedFilesMap = this.getCurrentFilesMap(currentFilesMap, file, partNumber, index);
            this.filesMapSubject.next(updatedFilesMap);
        } else {
            const currentFilesMap = this.nullFileSubject.getValue();
            const partNumberMap = partNumber + '/' + index;
            const updatedFilesMap = this.getCurrentFilesMap(currentFilesMap, file, partNumberMap, index);
            this.nullFileSubject.next(updatedFilesMap);
        }
    }

    getCurrentFilesMap(currentFilesMap, file: File, partNumber: string, index: number) {
        const filesForPartNumber = currentFilesMap[partNumber] || [];
        const updatedFilesMap = {
            ...currentFilesMap,
            [partNumber]: [...filesForPartNumber, file],
            [index]: [...filesForPartNumber, file].length,
        };
        return updatedFilesMap;
    }

    deleteFile(fileName: string, partNumber: string, index): void {
        const currentFilesMap = this.filesMapSubject.getValue();
        const updatedFilesForPartNumber = currentFilesMap[partNumber].filter((file) => file.name !== fileName);
        const updatedFilesMap = {
            ...currentFilesMap,
            [partNumber]: updatedFilesForPartNumber,
            [index]: [...updatedFilesForPartNumber].length,
        };
        this.filesMapSubject.next(updatedFilesMap);
    }

    clearAllFiles() {
        this.filesMapSubject.next([]);
        this.nullFileSubject.next([]);
    }

    getCurrentFileCount(partNumber: string): Observable<number> {
        return this.filesMap$.pipe(map((filesMap) => (filesMap[partNumber] || []).length));
    }

    getCurrentFilesInfo(partNumber: string): Observable<{ name: string; size: number }[]> {
        return this.filesMap$.pipe(
            map((filesMap) => (filesMap[partNumber] || []).map((file) => ({ name: file.name, size: file.size / 1024 })))
        );
    }

    isNotDuplicate(fileName: string, partNumber: string): boolean {
        const currentFilesMap = this.filesMapSubject.getValue();
        return !(currentFilesMap[partNumber] || []).some((file) => file.name === fileName);
    }

    getAllFiles(partNumber: string): File[] {
        const currentFilesMap = this.filesMapSubject.getValue();
        return currentFilesMap[partNumber] || [];
    }

    isFileSizeLessThan9MB(file: File): boolean {
        return file.size <= 9 * 1024 * 1024;
    }

    isTotalFileSizeLessThan9MB(partNumber: string): boolean {
        const totalSize = (this.filesMapSubject.getValue()[partNumber] || []).reduce((acc, file) => acc + file.size, 0);
        return totalSize <= 9 * 1024 * 1024;
    }

    isAtLeastOneFilePresent(partNumber: string): boolean {
        return (this.filesMapSubject.getValue()[partNumber] || []).length > 0;
    }
    uploadTheFilesOnebyOne(claimNumber) {
        const filesMap = this.filesMapSubject.getValue();
        const nullFileSubject = this.nullFileSubject.getValue();
        const allKeys = { ...nullFileSubject, ...filesMap };
        const fileKeys = Object.keys(allKeys).filter((item) => item.length > 1);
        this.fileUploadObjects(fileKeys, allKeys, claimNumber);
    }

    fileUploadObjects(fileKeys, filesMap, claimNumber) {
        fileKeys.forEach((partNumber, index) => {
            const formData = new FormData();
            const filesForPart = filesMap[partNumber];
            formData.append('claimNumber', claimNumber);
            formData.append('partNumber', partNumber.split('/')[0]);
            formData.append('partEntry', (partNumber.split('/')[1] || index).toString());
            formData.append('isLastEntry', index === fileKeys.length - 1 ? 'true' : 'false');
            filesForPart.forEach((file) => {
                formData.append('file', file);
            });
            return this.uploadFiles(formData).subscribe(
                (next) => next,
                (error) => error.error
            );
        });
    }
    uploadFiles(payLoad: FormData) {
        const url = this.occEndpointsService.buildUrl('mywarranty/submitReturnAttachments');
        return this.http.post(url, payLoad);
    }
    //ticlets
    getLastFileNameTicket(): string | null {
        const currentFiles = this.filesSubject.getValue();
        return currentFiles.length > 0 ? currentFiles[currentFiles.length - 1].name : null;
    }
    addFileTicket(file: File): void {
        const currentFiles = this.filesSubject.getValue();
        const updatedFiles = [...currentFiles, file];
        this.filesSubject.next(updatedFiles);
    }
    getAllFilesTicket(): File[] {
        return this.filesSubject.getValue();
    }
}
